module.exports = __webpack_public_path__ + "img/m_service_code.cef98303.png";